import FontPicker from 'react-fontpicker-ts-lite'
import 'react-fontpicker-ts-lite/dist/index.css'
import React from 'react'
import { useEffect, useState } from 'react'
import { Select, Option } from '@mui/joy'
import { fonts } from './FontInfo'
import Typography from '@mui/joy/Typography'
import { useUpdateStoreMutation } from '../../services/branding'

function FontSelector() {
  const [fontsIndex, setFontsIndex] = useState(10)

  const [updateStore, { isLoading: isUpdateStoreLoading }] =
    useUpdateStoreMutation({ fixedCacheKey: 'shared-delete-reward' })

  useEffect(() => {
    if (fontsIndex <= 80) {
      setFontsIndex(fontsIndex + 10)
    }
  }, [fontsIndex])

  const handleSelectChange = (
    event: React.SyntheticEvent | null,
    newValue: string | null,
  ) => {
    updateStore({ font: newValue ?? 'Roboto' })
  }

  return (
    <>
      <FontPicker loaderOnly loadFonts={fonts.slice(0, fontsIndex)} />
      <label style={{ marginLeft: -14 }}>Font</label>
      <Select
        disabled={isUpdateStoreLoading}
        defaultValue="Roboto"
        onChange={handleSelectChange}
        sx={{ mt: 1, ml: -2, mr: -2 }}
      >
        {fonts.map((font) => (
          <Option key={font} value={font}>
            <Typography fontFamily={font}>{font}</Typography>
          </Option>
        ))}
      </Select>
    </>
  )
}

export default FontSelector
